var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-overlay',{attrs:{"show":_vm.show,"z-index":"3001"}},[_c('div',{staticClass:"loading_box"},[_c('van-loading',{attrs:{"type":"spinner","vertical":""}},[_vm._t("default")],2)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }